const state = {
  coverage: [],
  coverageuniversetab: [],
};
const actions = {};
const getters = {
  coverage: (state) => state.coverage,
  coverageuniversetab: (state) => state.coverageuniversetab,
};
const mutations = {
  SET_COVERAGE: (state, coverage) => {
    
    state.coverage = coverage;
  },
  SET_HISTORICALTOP10:  (state, coverage) => {
    state.coverageuniversetab = coverage;
  },
    SET_TRADING: (state, coverageuniversetab) => {
    let formattedData = coverageuniversetab.map(function(d){
      return {
        'Company Code':	d.companycode,
        'Company Name':	d.companyname,
        E_1:	parseFloat(parseFloat(d.e_1)),
        E_2:	parseFloat(parseFloat(d.e_2)),
        E_3:	parseFloat(parseFloat(d.e_3)),
        E_4:	parseFloat(parseFloat(d.e_4)),
        E_5:	parseFloat(parseFloat(d.e_5)),
        E_6:	parseFloat(parseFloat(d.e_6)),
        E_7:	parseFloat(parseFloat(d.e_7)),
        E_8:	parseFloat(parseFloat(d.e_8)),
        E_9:	parseFloat(parseFloat(d.e_9)),
        E_10:	parseFloat(parseFloat(d.e_10)),
        E_11:	parseFloat(parseFloat(d.e_11)),
        E_12:	parseFloat(parseFloat(d.e_12)),
        I_1:	parseFloat(parseFloat(d.i_1)),
        I_2:	parseFloat(parseFloat(d.i_2)),
        I_3:	parseFloat(parseFloat(d.i_3)),
        I_4:	parseFloat(parseFloat(d.i_4)),
        I_5:	parseFloat(parseFloat(d.i_5)),
        I_6:	parseFloat(parseFloat(d.i_6)),
        I_7:	parseFloat(parseFloat(d.i_7)),
        I_8:	parseFloat(parseFloat(d.i_8)),
        I_9:	parseFloat(parseFloat(d.i_9)),
        I_10:	parseFloat(parseFloat(d.i_10)),
        I_11:	parseFloat(parseFloat(d.i_11)),
        I_12:	parseFloat(parseFloat(d.i_12)),
        Year:	parseFloat(parseFloat(d.year)),

      };
    });

    sessionStorage.setItem("tradeData", JSON.stringify(formattedData));
    state.coverageuniversetab = coverageuniversetab;
  },
  SET_RATING:(state,rating)=>{
    let formattedData = rating.map(function(d){
      return {
        Buy:	d.buy,
        'Company Code':	d.companycode,
        'Company Name':	d.companyname,
        Hold:	d.hold,
        Month:	d.month,
        Outperform:	d.outperform,
        Report:	d.report,
        Sell:	d.sell,
        Underperform:	d.underperform
      }
    });
     sessionStorage.setItem("ratingData", JSON.stringify(formattedData));
}
};
export default {
  state,
  getters,
  actions,
  mutations,
};
